interface ColorsType {
    primary: string,
    spinner: string,
    skeleton: string
}


export const colors: ColorsType = {
    primary: "#28A8EF",
    spinner: "#0FB6C8",
    skeleton: "#ddd"

}
